/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import {
  restructureSpecialPagesListItemModel,
  restructureSpecialPagesModel
} from './restructuring';

class SpecialPagesService {
  async getSpecialPagesList(state, queryParams) {
    const response = await api.get(`/special-pages`, {
      expand: 'pageTags',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureSpecialPagesListItemModel(state, item)
          ),
          'seo_url'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.seo_url)
      }
    };
  }

  async getSpecialPagesById(state, id) {
    const response = await api.get(`/special-pages/${id}`, {
      expand: 'pageTags'
    });
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: _.keyBy(
        _.map([responseJson.data], item =>
          restructureSpecialPagesModel(state, item)
        ),
        'seo_url'
      )
    };
  }
}

export default new SpecialPagesService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/specialPages/services/SpecialPagesService/SpecialPagesService.js